<mat-card appearance="outlined" class="cohort-card">
  <mat-card-content>
    <div class="cohort-card__row">
      <img class="cohort-card__icon" src="./assets/images/icons8-edit.svg" alt="" aria-hidden="true" />
      <div class="cohort-card__content">
        <h3 id="cohort-phrase-title" class="cohort-card__title">Grant aid disclosure</h3>
        <p id="cohort-phrase-help" class="cohort-card__text">This sentence is required on calculator results.</p>
        <form [formGroup]="cohortForm" (ngSubmit)="save()" aria-labelledby="cohort-phrase-title" aria-describedby="cohort-phrase-help">
          <p class="cohort-card__phrase">
            <span>In</span>
            <span class="cohort-card__year">
              <mat-form-field appearance="outline" subscriptSizing="dynamic" class="cohort-card__field cohort-card__field--year">
                <mat-label>Aid year</mat-label>
                <mat-select formControlName="cohortAidPercentYear">
                  @for (year of cohortYears; track year) {
                    <mat-option [value]="year">{{ year }}</mat-option>
                  }
                  @if (legacyCohortYear; as year) {
                    <mat-option [value]="year" disabled>{{ year }} (no longer available)</mat-option>
                  }
                </mat-select>
                @if (cohortForm.controls["cohortAidPercentYear"].hasError("required")) {
                  <mat-error>Select an aid year.</mat-error>
                }
              </mat-form-field>
            </span>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="cohort-card__field cohort-card__field--percent">
              <mat-label>Aid percent</mat-label>
              <input #aidPercent matInput type="number" min="0" max="100" formControlName="cohortAidPercent" data-lpignore="true" readonly (focus)="aidPercent.readOnly = false" />
              <span matSuffix>%</span>
              @if (cohortForm.controls["cohortAidPercent"].hasError("required")) {
                <mat-error>Add a percent.</mat-error>
              }
              @if (cohortForm.controls["cohortAidPercent"].hasError("min") || cohortForm.controls["cohortAidPercent"].hasError("max")) {
                <mat-error>Enter 0 to 100.</mat-error>
              }
            </mat-form-field>
            <span>of our full-time beginning undergraduates received grant/scholarship aid.</span>
          </p>
          <div class="cohort-card__actions">
            <button mat-stroked-button color="primary" type="submit" [disabled]="cohortForm.invalid || !cohortForm.dirty || saving">
              {{ saving ? "Saving…" : "Save" }}
            </button>
            <span aria-live="polite">{{ saveStatus }}</span>
          </div>
        </form>
      </div>
    </div>
  </mat-card-content>
</mat-card>
